import { render, staticRenderFns } from "./TermsAndPolicy.vue?vue&type=template&id=0f637b73&scoped=true&"
import script from "./TermsAndPolicy.vue?vue&type=script&lang=js&"
export * from "./TermsAndPolicy.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndPolicy.vue?vue&type=style&index=0&id=0f637b73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f637b73",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/uu264406/workDirectory/shingaku/reset_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f637b73')) {
      api.createRecord('0f637b73', component.options)
    } else {
      api.reload('0f637b73', component.options)
    }
    module.hot.accept("./TermsAndPolicy.vue?vue&type=template&id=0f637b73&scoped=true&", function () {
      api.rerender('0f637b73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/contents/components/common/common/Text/TermsAndPolicy.vue"
export default component.exports